import { appConfig } from '../env.js';
import { region } from '../env.js';
import { track } from './index.js';
import type { Step } from './events.js';

const started = new Set<string>();
const advancing = new Set<Step>();
export function plannerLanded(path: string): void {
  if (!/^\/planner\/(type|measure|lock|colour|review)$/.test(path)) return;
  const key = `${appConfig.appName}:${region.code}:analytics-started`;
  try {
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, '1');
  } catch {
    console.warn('Analytics: session storage is unavailable; session deduplication is in memory.');
    if (started.has(key)) return;
    started.add(key);
  }
  track('planner_started', {});
}

export async function completeStep(
  step: Step,
  advance: () => Promise<void>,
  arrived: () => boolean,
): Promise<boolean> {
  if (advancing.has(step)) return false;
  advancing.add(step);
  try {
    await advance();
    if (arrived()) {
      track('planner_step_completed', { step });
      return true;
    }
    console.warn('Analytics: Continue did not reach its destination.');
  } catch {
    console.warn('Analytics: Continue navigation failed.');
  } finally {
    advancing.delete(step);
  }
  return false;
}
